//THIS FILE IS AUTO GENERATED
//DO NOT EDIT AND DELETE IT

    

      import ChangeLinkTypeDialogarSAUrl from "ASSETS_DIR/locales/ar-SA/ChangeLinkTypeDialog.json";

      import CompletedFormarSAUrl from "ASSETS_DIR/locales/ar-SA/CompletedForm.json";

      import DeepLinkarSAUrl from "ASSETS_DIR/locales/ar-SA/DeepLink.json";

      import EditorarSAUrl from "ASSETS_DIR/locales/ar-SA/Editor.json";

      import ChangeLinkTypeDialogazUrl from "ASSETS_DIR/locales/az/ChangeLinkTypeDialog.json";

      import CompletedFormazUrl from "ASSETS_DIR/locales/az/CompletedForm.json";

      import DeepLinkazUrl from "ASSETS_DIR/locales/az/DeepLink.json";

      import EditorazUrl from "ASSETS_DIR/locales/az/Editor.json";

      import ChangeLinkTypeDialogbgUrl from "ASSETS_DIR/locales/bg/ChangeLinkTypeDialog.json";

      import CompletedFormbgUrl from "ASSETS_DIR/locales/bg/CompletedForm.json";

      import DeepLinkbgUrl from "ASSETS_DIR/locales/bg/DeepLink.json";

      import EditorbgUrl from "ASSETS_DIR/locales/bg/Editor.json";

      import ChangeLinkTypeDialogcsUrl from "ASSETS_DIR/locales/cs/ChangeLinkTypeDialog.json";

      import CompletedFormcsUrl from "ASSETS_DIR/locales/cs/CompletedForm.json";

      import DeepLinkcsUrl from "ASSETS_DIR/locales/cs/DeepLink.json";

      import EditorcsUrl from "ASSETS_DIR/locales/cs/Editor.json";

      import ChangeLinkTypeDialogdeUrl from "ASSETS_DIR/locales/de/ChangeLinkTypeDialog.json";

      import CompletedFormdeUrl from "ASSETS_DIR/locales/de/CompletedForm.json";

      import DeepLinkdeUrl from "ASSETS_DIR/locales/de/DeepLink.json";

      import EditordeUrl from "ASSETS_DIR/locales/de/Editor.json";

      import ChangeLinkTypeDialogelGRUrl from "ASSETS_DIR/locales/el-GR/ChangeLinkTypeDialog.json";

      import CompletedFormelGRUrl from "ASSETS_DIR/locales/el-GR/CompletedForm.json";

      import DeepLinkelGRUrl from "ASSETS_DIR/locales/el-GR/DeepLink.json";

      import EditorelGRUrl from "ASSETS_DIR/locales/el-GR/Editor.json";

      import ChangeLinkTypeDialogenUrl from "ASSETS_DIR/locales/en/ChangeLinkTypeDialog.json";

      import CompletedFormenUrl from "ASSETS_DIR/locales/en/CompletedForm.json";

      import DeepLinkenUrl from "ASSETS_DIR/locales/en/DeepLink.json";

      import EditorenUrl from "ASSETS_DIR/locales/en/Editor.json";

      import ChangeLinkTypeDialogesUrl from "ASSETS_DIR/locales/es/ChangeLinkTypeDialog.json";

      import CompletedFormesUrl from "ASSETS_DIR/locales/es/CompletedForm.json";

      import DeepLinkesUrl from "ASSETS_DIR/locales/es/DeepLink.json";

      import EditoresUrl from "ASSETS_DIR/locales/es/Editor.json";

      import ChangeLinkTypeDialogfiUrl from "ASSETS_DIR/locales/fi/ChangeLinkTypeDialog.json";

      import CompletedFormfiUrl from "ASSETS_DIR/locales/fi/CompletedForm.json";

      import DeepLinkfiUrl from "ASSETS_DIR/locales/fi/DeepLink.json";

      import EditorfiUrl from "ASSETS_DIR/locales/fi/Editor.json";

      import ChangeLinkTypeDialogfrUrl from "ASSETS_DIR/locales/fr/ChangeLinkTypeDialog.json";

      import CompletedFormfrUrl from "ASSETS_DIR/locales/fr/CompletedForm.json";

      import DeepLinkfrUrl from "ASSETS_DIR/locales/fr/DeepLink.json";

      import EditorfrUrl from "ASSETS_DIR/locales/fr/Editor.json";

      import ChangeLinkTypeDialoghyAMUrl from "ASSETS_DIR/locales/hy-AM/ChangeLinkTypeDialog.json";

      import CompletedFormhyAMUrl from "ASSETS_DIR/locales/hy-AM/CompletedForm.json";

      import DeepLinkhyAMUrl from "ASSETS_DIR/locales/hy-AM/DeepLink.json";

      import EditorhyAMUrl from "ASSETS_DIR/locales/hy-AM/Editor.json";

      import ChangeLinkTypeDialogitUrl from "ASSETS_DIR/locales/it/ChangeLinkTypeDialog.json";

      import CompletedFormitUrl from "ASSETS_DIR/locales/it/CompletedForm.json";

      import DeepLinkitUrl from "ASSETS_DIR/locales/it/DeepLink.json";

      import EditoritUrl from "ASSETS_DIR/locales/it/Editor.json";

      import ChangeLinkTypeDialogjaJPUrl from "ASSETS_DIR/locales/ja-JP/ChangeLinkTypeDialog.json";

      import CompletedFormjaJPUrl from "ASSETS_DIR/locales/ja-JP/CompletedForm.json";

      import DeepLinkjaJPUrl from "ASSETS_DIR/locales/ja-JP/DeepLink.json";

      import EditorjaJPUrl from "ASSETS_DIR/locales/ja-JP/Editor.json";

      import ChangeLinkTypeDialogkoKRUrl from "ASSETS_DIR/locales/ko-KR/ChangeLinkTypeDialog.json";

      import CompletedFormkoKRUrl from "ASSETS_DIR/locales/ko-KR/CompletedForm.json";

      import DeepLinkkoKRUrl from "ASSETS_DIR/locales/ko-KR/DeepLink.json";

      import EditorkoKRUrl from "ASSETS_DIR/locales/ko-KR/Editor.json";

      import ChangeLinkTypeDialogloLAUrl from "ASSETS_DIR/locales/lo-LA/ChangeLinkTypeDialog.json";

      import CompletedFormloLAUrl from "ASSETS_DIR/locales/lo-LA/CompletedForm.json";

      import DeepLinkloLAUrl from "ASSETS_DIR/locales/lo-LA/DeepLink.json";

      import EditorloLAUrl from "ASSETS_DIR/locales/lo-LA/Editor.json";

      import ChangeLinkTypeDialoglvUrl from "ASSETS_DIR/locales/lv/ChangeLinkTypeDialog.json";

      import CompletedFormlvUrl from "ASSETS_DIR/locales/lv/CompletedForm.json";

      import DeepLinklvUrl from "ASSETS_DIR/locales/lv/DeepLink.json";

      import EditorlvUrl from "ASSETS_DIR/locales/lv/Editor.json";

      import ChangeLinkTypeDialognlUrl from "ASSETS_DIR/locales/nl/ChangeLinkTypeDialog.json";

      import CompletedFormnlUrl from "ASSETS_DIR/locales/nl/CompletedForm.json";

      import DeepLinknlUrl from "ASSETS_DIR/locales/nl/DeepLink.json";

      import EditornlUrl from "ASSETS_DIR/locales/nl/Editor.json";

      import ChangeLinkTypeDialogplUrl from "ASSETS_DIR/locales/pl/ChangeLinkTypeDialog.json";

      import CompletedFormplUrl from "ASSETS_DIR/locales/pl/CompletedForm.json";

      import DeepLinkplUrl from "ASSETS_DIR/locales/pl/DeepLink.json";

      import EditorplUrl from "ASSETS_DIR/locales/pl/Editor.json";

      import ChangeLinkTypeDialogptUrl from "ASSETS_DIR/locales/pt/ChangeLinkTypeDialog.json";

      import CompletedFormptUrl from "ASSETS_DIR/locales/pt/CompletedForm.json";

      import DeepLinkptUrl from "ASSETS_DIR/locales/pt/DeepLink.json";

      import EditorptUrl from "ASSETS_DIR/locales/pt/Editor.json";

      import ChangeLinkTypeDialogptBRUrl from "ASSETS_DIR/locales/pt-BR/ChangeLinkTypeDialog.json";

      import CompletedFormptBRUrl from "ASSETS_DIR/locales/pt-BR/CompletedForm.json";

      import DeepLinkptBRUrl from "ASSETS_DIR/locales/pt-BR/DeepLink.json";

      import EditorptBRUrl from "ASSETS_DIR/locales/pt-BR/Editor.json";

      import ChangeLinkTypeDialogroUrl from "ASSETS_DIR/locales/ro/ChangeLinkTypeDialog.json";

      import CompletedFormroUrl from "ASSETS_DIR/locales/ro/CompletedForm.json";

      import DeepLinkroUrl from "ASSETS_DIR/locales/ro/DeepLink.json";

      import EditorroUrl from "ASSETS_DIR/locales/ro/Editor.json";

      import ChangeLinkTypeDialogruUrl from "ASSETS_DIR/locales/ru/ChangeLinkTypeDialog.json";

      import CompletedFormruUrl from "ASSETS_DIR/locales/ru/CompletedForm.json";

      import DeepLinkruUrl from "ASSETS_DIR/locales/ru/DeepLink.json";

      import EditorruUrl from "ASSETS_DIR/locales/ru/Editor.json";

      import ChangeLinkTypeDialogsiUrl from "ASSETS_DIR/locales/si/ChangeLinkTypeDialog.json";

      import CompletedFormsiUrl from "ASSETS_DIR/locales/si/CompletedForm.json";

      import DeepLinksiUrl from "ASSETS_DIR/locales/si/DeepLink.json";

      import EditorsiUrl from "ASSETS_DIR/locales/si/Editor.json";

      import ChangeLinkTypeDialogskUrl from "ASSETS_DIR/locales/sk/ChangeLinkTypeDialog.json";

      import CompletedFormskUrl from "ASSETS_DIR/locales/sk/CompletedForm.json";

      import DeepLinkskUrl from "ASSETS_DIR/locales/sk/DeepLink.json";

      import EditorskUrl from "ASSETS_DIR/locales/sk/Editor.json";

      import ChangeLinkTypeDialogslUrl from "ASSETS_DIR/locales/sl/ChangeLinkTypeDialog.json";

      import CompletedFormslUrl from "ASSETS_DIR/locales/sl/CompletedForm.json";

      import DeepLinkslUrl from "ASSETS_DIR/locales/sl/DeepLink.json";

      import EditorslUrl from "ASSETS_DIR/locales/sl/Editor.json";

      import ChangeLinkTypeDialogsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/ChangeLinkTypeDialog.json";

      import CompletedFormsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/CompletedForm.json";

      import DeepLinksrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/DeepLink.json";

      import EditorsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Editor.json";

      import ChangeLinkTypeDialogsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/ChangeLinkTypeDialog.json";

      import CompletedFormsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/CompletedForm.json";

      import DeepLinksrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/DeepLink.json";

      import EditorsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Editor.json";

      import ChangeLinkTypeDialogtrUrl from "ASSETS_DIR/locales/tr/ChangeLinkTypeDialog.json";

      import CompletedFormtrUrl from "ASSETS_DIR/locales/tr/CompletedForm.json";

      import DeepLinktrUrl from "ASSETS_DIR/locales/tr/DeepLink.json";

      import EditortrUrl from "ASSETS_DIR/locales/tr/Editor.json";

      import ChangeLinkTypeDialogukUAUrl from "ASSETS_DIR/locales/uk-UA/ChangeLinkTypeDialog.json";

      import CompletedFormukUAUrl from "ASSETS_DIR/locales/uk-UA/CompletedForm.json";

      import DeepLinkukUAUrl from "ASSETS_DIR/locales/uk-UA/DeepLink.json";

      import EditorukUAUrl from "ASSETS_DIR/locales/uk-UA/Editor.json";

      import ChangeLinkTypeDialogviUrl from "ASSETS_DIR/locales/vi/ChangeLinkTypeDialog.json";

      import CompletedFormviUrl from "ASSETS_DIR/locales/vi/CompletedForm.json";

      import DeepLinkviUrl from "ASSETS_DIR/locales/vi/DeepLink.json";

      import EditorviUrl from "ASSETS_DIR/locales/vi/Editor.json";

      import ChangeLinkTypeDialogzhCNUrl from "ASSETS_DIR/locales/zh-CN/ChangeLinkTypeDialog.json";

      import CompletedFormzhCNUrl from "ASSETS_DIR/locales/zh-CN/CompletedForm.json";

      import DeepLinkzhCNUrl from "ASSETS_DIR/locales/zh-CN/DeepLink.json";

      import EditorzhCNUrl from "ASSETS_DIR/locales/zh-CN/Editor.json";

      import CommonarSAUrl from "PUBLIC_DIR/locales/ar-SA/Common.json";

      import CommonazUrl from "PUBLIC_DIR/locales/az/Common.json";

      import CommonbgUrl from "PUBLIC_DIR/locales/bg/Common.json";

      import CommoncsUrl from "PUBLIC_DIR/locales/cs/Common.json";

      import CommondeUrl from "PUBLIC_DIR/locales/de/Common.json";

      import CommonelGRUrl from "PUBLIC_DIR/locales/el-GR/Common.json";

      import CommonenUrl from "PUBLIC_DIR/locales/en/Common.json";

      import CommonesUrl from "PUBLIC_DIR/locales/es/Common.json";

      import CommonfiUrl from "PUBLIC_DIR/locales/fi/Common.json";

      import CommonfrUrl from "PUBLIC_DIR/locales/fr/Common.json";

      import CommonhyAMUrl from "PUBLIC_DIR/locales/hy-AM/Common.json";

      import CommonitUrl from "PUBLIC_DIR/locales/it/Common.json";

      import CommonjaJPUrl from "PUBLIC_DIR/locales/ja-JP/Common.json";

      import CommonkoKRUrl from "PUBLIC_DIR/locales/ko-KR/Common.json";

      import CommonloLAUrl from "PUBLIC_DIR/locales/lo-LA/Common.json";

      import CommonlvUrl from "PUBLIC_DIR/locales/lv/Common.json";

      import CommonnlUrl from "PUBLIC_DIR/locales/nl/Common.json";

      import CommonplUrl from "PUBLIC_DIR/locales/pl/Common.json";

      import CommonptUrl from "PUBLIC_DIR/locales/pt/Common.json";

      import CommonptBRUrl from "PUBLIC_DIR/locales/pt-BR/Common.json";

      import CommonroUrl from "PUBLIC_DIR/locales/ro/Common.json";

      import CommonruUrl from "PUBLIC_DIR/locales/ru/Common.json";

      import CommonsiUrl from "PUBLIC_DIR/locales/si/Common.json";

      import CommonskUrl from "PUBLIC_DIR/locales/sk/Common.json";

      import CommonslUrl from "PUBLIC_DIR/locales/sl/Common.json";

      import CommonsrCyrlRSUrl from "PUBLIC_DIR/locales/sr-Cyrl-RS/Common.json";

      import CommonsrLatnRSUrl from "PUBLIC_DIR/locales/sr-Latn-RS/Common.json";

      import CommontrUrl from "PUBLIC_DIR/locales/tr/Common.json";

      import CommonukUAUrl from "PUBLIC_DIR/locales/uk-UA/Common.json";

      import CommonviUrl from "PUBLIC_DIR/locales/vi/Common.json";

      import CommonzhCNUrl from "PUBLIC_DIR/locales/zh-CN/Common.json";

 const arSA = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogarSAUrl],
["CompletedForm", CompletedFormarSAUrl],
["DeepLink", DeepLinkarSAUrl],
["Editor", EditorarSAUrl],
["Common", CommonarSAUrl]
]);
 const az = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogazUrl],
["CompletedForm", CompletedFormazUrl],
["DeepLink", DeepLinkazUrl],
["Editor", EditorazUrl],
["Common", CommonazUrl]
]);
 const bg = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogbgUrl],
["CompletedForm", CompletedFormbgUrl],
["DeepLink", DeepLinkbgUrl],
["Editor", EditorbgUrl],
["Common", CommonbgUrl]
]);
 const cs = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogcsUrl],
["CompletedForm", CompletedFormcsUrl],
["DeepLink", DeepLinkcsUrl],
["Editor", EditorcsUrl],
["Common", CommoncsUrl]
]);
 const de = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogdeUrl],
["CompletedForm", CompletedFormdeUrl],
["DeepLink", DeepLinkdeUrl],
["Editor", EditordeUrl],
["Common", CommondeUrl]
]);
 const elGR = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogelGRUrl],
["CompletedForm", CompletedFormelGRUrl],
["DeepLink", DeepLinkelGRUrl],
["Editor", EditorelGRUrl],
["Common", CommonelGRUrl]
]);
 const en = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogenUrl],
["CompletedForm", CompletedFormenUrl],
["DeepLink", DeepLinkenUrl],
["Editor", EditorenUrl],
["Common", CommonenUrl]
]);
 const es = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogesUrl],
["CompletedForm", CompletedFormesUrl],
["DeepLink", DeepLinkesUrl],
["Editor", EditoresUrl],
["Common", CommonesUrl]
]);
 const fi = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogfiUrl],
["CompletedForm", CompletedFormfiUrl],
["DeepLink", DeepLinkfiUrl],
["Editor", EditorfiUrl],
["Common", CommonfiUrl]
]);
 const fr = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogfrUrl],
["CompletedForm", CompletedFormfrUrl],
["DeepLink", DeepLinkfrUrl],
["Editor", EditorfrUrl],
["Common", CommonfrUrl]
]);
 const hyAM = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialoghyAMUrl],
["CompletedForm", CompletedFormhyAMUrl],
["DeepLink", DeepLinkhyAMUrl],
["Editor", EditorhyAMUrl],
["Common", CommonhyAMUrl]
]);
 const it = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogitUrl],
["CompletedForm", CompletedFormitUrl],
["DeepLink", DeepLinkitUrl],
["Editor", EditoritUrl],
["Common", CommonitUrl]
]);
 const jaJP = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogjaJPUrl],
["CompletedForm", CompletedFormjaJPUrl],
["DeepLink", DeepLinkjaJPUrl],
["Editor", EditorjaJPUrl],
["Common", CommonjaJPUrl]
]);
 const koKR = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogkoKRUrl],
["CompletedForm", CompletedFormkoKRUrl],
["DeepLink", DeepLinkkoKRUrl],
["Editor", EditorkoKRUrl],
["Common", CommonkoKRUrl]
]);
 const loLA = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogloLAUrl],
["CompletedForm", CompletedFormloLAUrl],
["DeepLink", DeepLinkloLAUrl],
["Editor", EditorloLAUrl],
["Common", CommonloLAUrl]
]);
 const lv = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialoglvUrl],
["CompletedForm", CompletedFormlvUrl],
["DeepLink", DeepLinklvUrl],
["Editor", EditorlvUrl],
["Common", CommonlvUrl]
]);
 const nl = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialognlUrl],
["CompletedForm", CompletedFormnlUrl],
["DeepLink", DeepLinknlUrl],
["Editor", EditornlUrl],
["Common", CommonnlUrl]
]);
 const pl = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogplUrl],
["CompletedForm", CompletedFormplUrl],
["DeepLink", DeepLinkplUrl],
["Editor", EditorplUrl],
["Common", CommonplUrl]
]);
 const pt = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogptUrl],
["CompletedForm", CompletedFormptUrl],
["DeepLink", DeepLinkptUrl],
["Editor", EditorptUrl],
["Common", CommonptUrl]
]);
 const ptBR = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogptBRUrl],
["CompletedForm", CompletedFormptBRUrl],
["DeepLink", DeepLinkptBRUrl],
["Editor", EditorptBRUrl],
["Common", CommonptBRUrl]
]);
 const ro = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogroUrl],
["CompletedForm", CompletedFormroUrl],
["DeepLink", DeepLinkroUrl],
["Editor", EditorroUrl],
["Common", CommonroUrl]
]);
 const ru = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogruUrl],
["CompletedForm", CompletedFormruUrl],
["DeepLink", DeepLinkruUrl],
["Editor", EditorruUrl],
["Common", CommonruUrl]
]);
 const si = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogsiUrl],
["CompletedForm", CompletedFormsiUrl],
["DeepLink", DeepLinksiUrl],
["Editor", EditorsiUrl],
["Common", CommonsiUrl]
]);
 const sk = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogskUrl],
["CompletedForm", CompletedFormskUrl],
["DeepLink", DeepLinkskUrl],
["Editor", EditorskUrl],
["Common", CommonskUrl]
]);
 const sl = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogslUrl],
["CompletedForm", CompletedFormslUrl],
["DeepLink", DeepLinkslUrl],
["Editor", EditorslUrl],
["Common", CommonslUrl]
]);
 const srCyrlRS = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogsrCyrlRSUrl],
["CompletedForm", CompletedFormsrCyrlRSUrl],
["DeepLink", DeepLinksrCyrlRSUrl],
["Editor", EditorsrCyrlRSUrl],
["Common", CommonsrCyrlRSUrl]
]);
 const srLatnRS = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogsrLatnRSUrl],
["CompletedForm", CompletedFormsrLatnRSUrl],
["DeepLink", DeepLinksrLatnRSUrl],
["Editor", EditorsrLatnRSUrl],
["Common", CommonsrLatnRSUrl]
]);
 const tr = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogtrUrl],
["CompletedForm", CompletedFormtrUrl],
["DeepLink", DeepLinktrUrl],
["Editor", EditortrUrl],
["Common", CommontrUrl]
]);
 const ukUA = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogukUAUrl],
["CompletedForm", CompletedFormukUAUrl],
["DeepLink", DeepLinkukUAUrl],
["Editor", EditorukUAUrl],
["Common", CommonukUAUrl]
]);
 const vi = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogviUrl],
["CompletedForm", CompletedFormviUrl],
["DeepLink", DeepLinkviUrl],
["Editor", EditorviUrl],
["Common", CommonviUrl]
]);
 const zhCN = new Map([
["ChangeLinkTypeDialog", ChangeLinkTypeDialogzhCNUrl],
["CompletedForm", CompletedFormzhCNUrl],
["DeepLink", DeepLinkzhCNUrl],
["Editor", EditorzhCNUrl],
["Common", CommonzhCNUrl]
]);
 export const translations = new Map([
["ar-SA", arSA],
["az", az],
["bg", bg],
["cs", cs],
["de", de],
["el-GR", elGR],
["en", en],
["es", es],
["fi", fi],
["fr", fr],
["hy-AM", hyAM],
["it", it],
["ja-JP", jaJP],
["ko-KR", koKR],
["lo-LA", loLA],
["lv", lv],
["nl", nl],
["pl", pl],
["pt", pt],
["pt-BR", ptBR],
["ro", ro],
["ru", ru],
["si", si],
["sk", sk],
["sl", sl],
["sr-Cyrl-RS", srCyrlRS],
["sr-Latn-RS", srLatnRS],
["tr", tr],
["uk-UA", ukUA],
["vi", vi],
["zh-CN", zhCN],
]);